// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__5C1nE","rightAdornment":"Header_rightAdornment__4hcJS"};